import { Group } from '@mantine/core';
import { trackEvent } from '@repo/common/analytics';
import { Button } from '@repo/foundations';
import { observer } from 'mobx-react-lite';
import { useNavigate } from 'react-router';
import { useAuthUser } from '../../../../api';

import { useCallback } from 'react';
import { entityModalStore } from '../../store';

function GlossaryTermFooter() {
	const { user, workspace } = useAuthUser();
	const navigate = useNavigate();

	const handleOnClick = useCallback(() => {
		trackEvent('glossary/create', {}, user, workspace!);
		entityModalStore.createGlossaryTerm(navigate);
	}, [navigate, user, workspace]);

	return (
		<Group position="right">
			<Button
				onClick={handleOnClick}
				loading={entityModalStore.loading}
				variant="primary"
			>
				Create term
			</Button>
		</Group>
	);
}

const GlossaryTermFooterObserver = observer(GlossaryTermFooter);
export default GlossaryTermFooterObserver;
